import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, checkPermission } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { CaretIcon, CaretUpIcon, Menu as MenuIcons, Calendar, CheckGreenCircle, CloseRedIcon, NoPlanIcon } from 'assets/icons';
import { HomeService } from 'services';
import moment from 'moment';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	since: moment().startOf('month').toDate(),
	until: moment().endOf('month').toDate(),
}

class Home extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Cliente',
			'KYC',
			'Documentos',
			'Facturas',
			'Acciones'
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		visible: false,
		item: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Dashboard',
				onBack: null,
				subtitle: 'Visualiza el estado general y las métricas clave del sistema.',
				color: '#edf0fe',
				icon: MenuIcons.Menu1
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await HomeService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
		});
		this.setState({
			data: res.users.rows,
			last_page: res.users.count
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	render() {
		const item: any = this.state.item;
		const { visible } = this.state;

		return (
			<div id="admin-home">
				<div className="row text-right">
					<div className="col-md-12">
						<div className="row-filter">
							<img src={ Calendar } />
							<div>
								<p className="label">Periodo</p>
								<div style={{ display: 'flex', alignItems: 'center' }}>
									<DatePicker
										customFormat="DD MMM"
										onChange={ (text: string) => {
											this.setState({
												form: {
													...this.state.form,
													since: text
												}
											},() => this.load(true));
										} }
										value={ this.state.form.since }
									/>
									<p className="to">-</p>
									<DatePicker
										customFormat="DD MMM YYYY"
										onChange={ (text: string) => {
											this.setState({
												form: {
													...this.state.form,
													until: text
												}
											},() => this.load(true));
										} }
										value={ this.state.form.until }
									/>
								</div>
							</div>
						</div>
					</div>
				</div>

				<Table data={ this.state.data.length } header={ this.state.header }
					pagination={
						<Pagination 
							pages={ this.state.last_page } 
							active={ this.state.page }
							onChange={ async (page: number) => {
								await this.setState({
									page: page
								});
								this.load();
							} } />
					}
				>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<>
								<tr key={ index }>
									<td>
										<div className="container-initial">
											<p className="initial">{ (i?.name + ' ' + i?.lastname).substr(0,1) }</p>
											<div>
												<p>{ i?.name + ' ' + i?.lastname }</p>
												<p className="email">{ i?.email }</p>
											</div>
										</div>
									</td>
									<td className="quantity">{ i?.kyc_count }</td>
									<td className="quantity">{ i?.document_count }</td>
									<td className="quantity">{ i?.bill_count }</td>
									<td style={{ 'whiteSpace': 'nowrap' }}>
										<button className="btn btn-arrow" onClick={ () => {
											this.setState({
												visible: item?.id != i.id,
												item: item?.id != i.id ? i : null
											});
										} }>
											<img src={ item?.id == i.id ? CaretUpIcon : CaretIcon } />
										</button>
									</td>
								</tr>

								{
									item?.id == i.id && visible && (
										<tr className="special-tr">
											<td colSpan={ 5 }>
												<div className="row">
													<div className="col-md">
														<div className="container-white h-100">
															<div className="container-title">
																<div className="container-icon" style={{ backgroundColor: '#ebf9f2' }}>
																	<img src={ MenuIcons.Menu9 } />
																</div>
																<p>KYC</p>
															</div>
															<div className="header">
																<div style={{ flex: .8 }}>
																	<p>Tipo</p>
																</div>
																<div style={{ flex: .2 }}>
																	<p className="text-right">Cantidad</p>
																</div>
															</div>
															<div className="scroll-item">
																{
																	i.kyc_plan ? (
																		<>
																			<div className="item">
																				<div style={{ flex: .8 }}>
																					<p>Verificaciones KYC</p>
																				</div>
																				<div style={{ flex: .2 }}>

																				</div>
																			</div>
																			<div className="item">
																				<div style={{ flex: .8, alignItems: 'center' }}>
																					<p className="sub-item">Verificación Simple</p>
																				</div>
																				<div style={{ flex: .2, textAlign: 'right' }}>
																					<img src={ CheckGreenCircle } className="circle-icon" />
																				</div>
																			</div>
																			<div className="item">
																				<div style={{ flex: .8, alignItems: 'center' }}>
																					<p className="sub-item">Liveness</p>
																				</div>
																				<div style={{ flex: .2, textAlign: 'right' }}>
																					<img src={ i?.liveness_config ? CheckGreenCircle : CloseRedIcon } className="circle-icon" />
																				</div>
																			</div>
																		</>
																	) : (
																		<div className="container-no-plan">
																			<div className="icon-container">
																				<img src={ NoPlanIcon } />
																			</div>

																			<p className="bold">Módulo de KYC</p>
																			<p className="title">No contratado</p>
																			<p className="text">Este cliente no tiene el módulo de KYC activado.</p>
																		</div>
																	)
																}
															</div>
															<div className="container-total">
																<p style={{ flex: 1 }}>Total KYC</p>
																<p className="text-right">{ i.kyc_plan ? i?.kyc_count : 'N/A' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-6">
														<div className="container-white h-100">
															<div className="container-title">
																<div className="container-icon" style={{ backgroundColor: '#f1f3fe' }}>
																	<img src={ MenuIcons.Menu5 } />
																</div>
																<p>Documentos</p>
															</div>
															<div className="container-separator h-100">
																{
																	i.document_plan != false && (
																		<>
																			<div style={{ flex: .5 }}>
																				<h6>Consumo por categoría</h6>
																				<div className="scroll-item">
																					{
																					    Object.entries(i?.document_categories || {}).map(([categoryName, categoryCount]: [string, any], index: number) => {
																					        const totalDocuments = i?.document_count ? parseInt(i.document_count, 10) : 0;
																					        const percentage = totalDocuments > 0 
																					            ? Math.round((parseInt(categoryCount, 10) / totalDocuments) * 100) 
																					            : 0;

																					        return (
																					            <div className="item" key={index}>
																					                <div className="container-letter">
																					                    <p>{ categoryName }</p>
																					                </div>
																					                <p>Categoría { categoryName }</p>
																					                <div style={{ flex: 1 }}>
																					                    <div className="percent-bar">
																					                        <div style={{ width: `${percentage}%` }} className="bar"></div>
																					                    </div>
																					                </div>
																					                <p style={{ width: '50px', textAlign: 'right' }}>{ categoryCount }</p>
																					            </div>
																					        )
																					    })
																					}
																				</div>
																			</div>
																			<div className="separator"></div>
																		</>
																	)
																}
																<div style={{ flex: i.document_plan ? .5 : 1 }}>
																	{
																		i.document_plan != false && (
																			<h6>Detalle por documento</h6>
																		)
																	}
																	<div className="header">
																		<div style={{ flex: .5 }}>
																			<p>Tipo</p>
																		</div>
																		<div style={{ flex: .3 }}>
																			<p className="text-center">Categoría</p>
																		</div>
																		<div style={{ flex: .2 }}>
																			<p className="text-right">Cantidad</p>
																		</div>
																	</div>
																	<div className="scroll-item">
																		{
																			i.document_plan ? (
																				<>
																					{
																						i?.document_verifications?.map((item: any) => {
																							return (
																								<div className="item">
																									<div style={{ flex: .5 }}>
																										<p>{ item?.document_type?.name }</p>
																									</div>
																									<div style={{ flex: .3, justifyContent: 'center', display: 'flex' }}>
																										<div className="container-letter">
																											<p>{ item?.document_type?.category }</p>
																										</div>
																									</div>
																									<div style={{ flex: .2 }}>
																										<p className="text-right">{ item?.count }</p>
																									</div>
																								</div>
																							)
																						})
																					}
																				</>
																			) : (
																				<div className="container-no-plan">
																					<div className="icon-container">
																						<img src={ NoPlanIcon } />
																					</div>

																					<p className="bold">Módulo de documentos</p>
																					<p className="title">No contratado</p>
																					<p className="text">Este cliente no tiene el módulo de documentos activado.</p>
																				</div>
																			)
																		}
																	</div>
																</div>
															</div>
															<div className="container-total">
																<p style={{ flex: 1 }}>Total Documentos</p>
																<p className="text-right">{ i.document_plan ? i?.document_count : 'N/A' }</p>
															</div>
														</div>
													</div>
													<div className="col-md">
														<div className="container-white h-100">
															<div className="container-title">
																<div className="container-icon" style={{ backgroundColor: '#edf0fe' }}>
																	<img src={ MenuIcons.Menu6 } />
																</div>
																<p>Facturas</p>
															</div>
															<div className="header">
																<div style={{ flex: .8 }}>
																	<p>Tipo</p>
																</div>
																<div style={{ flex: .2 }}>
																	<p className="text-right">Cantidad</p>
																</div>
															</div>
															<div className="scroll-item">
																{
																	i.bill_plan ? (
																		<>
																			<div className="item">
																				<div style={{ flex: .8 }}>
																					<p>Facturas procesadas</p>
																				</div>
																				<div style={{ flex: .2 }}>
																					<p className="text-right">{ i?.bill_count }</p>
																				</div>
																			</div>
																		</>
																	) : (
																		<div className="container-no-plan">
																			<div className="icon-container">
																				<img src={ NoPlanIcon } />
																			</div>

																			<p className="bold">Módulo de facturas</p>
																			<p className="title">No contratado</p>
																			<p className="text">Este cliente no tiene el módulo de facturas activado.</p>
																		</div>
																	)
																}																
															</div>
															<div className="container-total">
																<p style={{ flex: 1 }}>Total Facturas</p>
																<p className="text-right">{ i.bill_plan ? i?.bill_count : 'N/A' }</p>
															</div>
														</div>
													</div>
												</div>
											</td>
										</tr>
									)
								}
							</>
						)
					}) }
				</Table>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Home);